export default __webpack_public_path__ + "static/media/My-Cart.4fdab893.jpg";